import React, { useEffect, useState } from 'react';
import List from '../../node_modules/@mui/material/List/List';
import {RestFetcher} from '../helpers/RestFetcher'
import ListItemButton from '../../node_modules/@mui/material/ListItemButton/ListItemButton';
import ListItemText from '../../node_modules/@mui/material/ListItemText/ListItemText';
import { useGameState } from "../components/GameStateContext";
import { useNavigate } from 'react-router-dom';


function SelectRoomComponent({ onRoomSelected }) {

  //const { gameState, updateScore } = useGameState();
  const [roomState, setRoomState] = useState([]);

  
  function handleOnButtonClick() {    
  }

  useEffect(() => {
    console.log("SelectRoom useEffect");
    if (roomState.length === 0) { // If rooms have already been fetched, do not fetch again
      const fetcher = new RestFetcher();
      const fetchRooms = async () => {
        const rooms = await fetcher.fetchRooms(); // Assuming fetchRooms returns a promise
        if (rooms.success)
        {
          setRoomState(rooms.roomList); // Update state with fetched rooms
        }
        
      };
      
      fetchRooms(); // Call the async function to fetch rooms
    }
  }, [roomState]);

  const handleRoomClick = (roomName) => {
    onRoomSelected(roomName);
  };

  return (
    <div className="roomlist">
        <List component="nav">
            {roomState.map((room, index) => (
                <ListItemButton disableTypography={true} sx={{ display: 'flex', justifyContent: 'center' }} key={index} onClick={() => handleRoomClick(room.roomName)}>
                    <ListItemText disableTypography={true} primary={`${room.roomName} (${room.wordDifficulty.toLowerCase()})`} sx={{ textAlign: 'center' }} />
                </ListItemButton>
            ))}
        </List>
      
    </div>
  );
}


export default SelectRoomComponent;